import { render, staticRenderFns } from "./MenuBreadcrumb.vue?vue&type=template&id=3535006c&scoped=true&"
import script from "./MenuBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MenuBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MenuBreadcrumb.vue?vue&type=style&index=0&id=3535006c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535006c",
  null
  
)

export default component.exports